import React from 'react';
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 border-t border-gray-200" data-id="element-380">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-381">
        <div className="text-center mb-12" data-id="element-382">
          <div className="flex justify-center space-x-2 mb-8" data-id="element-383">
            <button className="w-3 h-3 rounded-full bg-[#214ae9]" data-id="element-384"></button>
            <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-385"></button>
            <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-386"></button>
          </div>
          <blockquote className="text-2xl md:text-3xl font-bold text-[#111111] max-w-4xl mx-auto leading-snug" data-id="element-387">
            "I used to spend hours every month helping my parents with their
            tech problems. Now they're actually confident — and I got my
            weekends back."
          </blockquote>
          <div className="mt-8" data-id="element-388">
            <p className="text-[#111111] font-bold" data-id="element-389">Sarah Chen</p>
            <p className="text-gray-500 text-sm" data-id="element-390">
              Guardian for her parents, ages 68 and 71
            </p>
          </div>
        </div>
      </div>
    </section>;
}